module.exports = __webpack_public_path__ + "img/rg-target-object-danger-default.75be0f39.svg";